import { ApiResponse } from "./../../../providers/api.service";
import { OnDestroy } from "@angular/core";
import {
  ChangeDetectorRef,
  Component,
  Inject,
  NgZone,
  OnInit,
} from "@angular/core";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "../../constants/sm-constants";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { v4 as uuidv4 } from "uuid";
import { WindowRefService } from "src/app/services/window-ref.service";
import { AnyAaaaRecord } from "dns";
import { CustomConfirmDialogComponent } from "../custom-confirm-dialog/custom-confirm-dialog.component";
import { parentPort } from "worker_threads";
import { environment } from "src/environments/environment";
import { FormControl } from "@angular/forms";
import { COUNTRY_CODES } from "../../data/country-codes";
declare var google: any;
declare var Razorpay: any;
@Component({
  selector: "sm-add-new-employee",
  templateUrl: "./add-new-employee.component.html",
  styleUrls: ["./add-new-employee.component.scss"],
})
export class AddNewEmployeeComponent implements OnInit, OnDestroy {
  private _apiSubscription: Subscription = new Subscription();
  noOfMonths: number = 1;
  noOfEmployees: number = 1;
  public newEmployeeObj: any = {
    requestUserName: null,
    requestUserPhone: null,
    note: null,
    joiningDate: null,
    joiningSalary: null,
    salaryType: null,
  };
  tochecksalon: boolean = false;
  tocheckbeautyparlour: boolean = false;
  tocheckspa: boolean = false;
  tocheckmakeup: boolean = false;

  entitySubscriptionHistoryData: any = [];
  plansList: any = [];
  editmode: boolean = false;
  constructor(
    private _apiService: ApiService,
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private ngZone: NgZone,
    private loaderService: LoaderServiceService,
    private winRef: WindowRefService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private activemodal: MatDialogRef<AddNewEmployeeComponent>
  ) {
    if (this.parentData.data && this.parentData.data != null) {
      console.log("data:::::::", this.parentData.data);
      this.editmode = true;
      this.toShowExistingPlans = false;
      this.toShowPlatformPlans = false;
      this.selectedCountryCode = this.countryList.find(country => country.dial_code === this.parentData.data.country_code)
      this.newEmployeeObj.employee_phone = this.parentData.data.employee_phone;
      this.newEmployeeObj.requestUserName = this.parentData.data.employee_name;
      this.newEmployeeObj.joiningSalary = this.parentData.data.joining_salary;
      this.newEmployeeObj.note = this.parentData.data.note;
      this.newEmployeeObj.joiningDate = this.parentData.data.date_of_join;

      this.toShowForm = true;
    } else {
      this.loaderService.showLoader = true;
      this._apiService.getSubcriptionHistoryById(
        localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
        "1",
        this.countryInfo.countryCode
      );
      this._apiService.getPlansList();
    }
  }
  countryInfo: any =
    typeof sessionStorage.getItem(
      SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
    ) == "string"
      ? JSON.parse(
          sessionStorage.getItem(
            SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT
          )!
        )
      : sessionStorage.getItem(SM_CONSTANTS.CURRENCY_FOR_SUBSCRIPTION_PAYMENT);

  ngOnInit(): void {
    this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_GET_SUBSCRIPTION_HISTORY_BY_ID
      ) {
        this.entitySubscriptionHistoryData = [];

        if (resData.result) {
          console.log(this.paymentResponse);

          if (this.paymentResponse && this.paymentResponse != null) {
            console.log("hitting null correct");

            resData.result.forEach((element: any) => {
              this.entitySubscriptionHistoryData.push(element);
            });
            this.selectedPlan = [this.entitySubscriptionHistoryData[0]];
          } else {
            console.log("hitting null wrong");
            resData.result.forEach((element: any) => {
              this.entitySubscriptionHistoryData.push(element);
            });
            this.toShowExistingPlans = true;
          }
        } else {
          this.toShowPlatformPlans = true;
          this.toShowMonths = false;
          this.toShowEmployees = false;
          this.noOfMonths = 1;
          this.noOfEmployees = 1;
        }
        this.loaderService.showLoader = false;
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_SEND_EMPLOYEE_REQUEST
      ) {
        if (resData.result) {
          this.paymentResponse = null;
          this.loaderService.showLoader = false;
          this.parentData.ref.closeAll();
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_EMPLOYEE_INFO
      ) {
        if (resData.result) {
          // this.paymentResponse = null
          this.loaderService.showLoader = false;
          this.activemodal.close({ msg: "success" });
          // this.parentData.ref.closeAll();
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_UPDATE_USER_SUBSCRIPTION_INFO
      ) {
        if (resData.result) {
          this.paymentResponse = null;
          this.parentData.ref.closeAll();
          this.loaderService.showLoader = false;
        }
      }
      if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_PLANS_LIST) {
        this.plansList = [];
        if (resData.result) {
          resData.result.forEach((element: any) => {
            if (element.eligibilityType == 2) {
              element.selected = false;
              this.plansList.push(element);
            }
          });
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_CREATE_SUBSCRIPTION_ORDER
      ) {
        if (resData.result) {
          this.payWithRazor(resData.result.id, resData.result.amount * 100);
        }
      }
      if (
        resData.responseType ===
        SM_CONSTANTS.RESULT_API_VALIDATE_PAYMENT_SIGNATURE
      ) {
        if (resData.result) {
          if (resData.result.signatureIsValid == "true") {
            console.log(this.selectedPlan);
            console.log(+this.selectedPlan[0].validity.split(" ")[0]);

            let data = {
              transactionInfo: {
                planHash: this.selectedPlan[0].hash_id,
                noOfUsers: this.noOfEmployees,
                noOfEntity: 0,
                fromDate: this.formatDateString(new Date()),
                toDate: this.addDaysToDate(
                  new Date(),
                  +this.selectedPlan[0].validity.split(" ")[0] * this.noOfMonths
                ),
                validity:
                  +this.selectedPlan[0].validity.split(" ")[0] *
                  this.noOfMonths,
                totalCost:
                  this.selectedPlan[0].perUnitCost *
                  this.noOfMonths *
                  this.noOfEmployees,
                unitCost: this.selectedPlan[0].perUnitCost,
                paymentType: 1,
                paymentRef: this.paymentResponse.razorpay_payment_id,
                currency: this.selectedPlan[0].currency,
                currencySymbol: this.selectedPlan[0].currency_symbol,
              },
            };

            this._apiService.updatePaymentRecord(data);
          }
        }
      }
      if (
        resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_PAYMENT_RECORD
      ) {
        console.log(this.toShowPlatformPlans, this.toShowForm);
        if (resData.result) {
          this.toShowPlatformPlans = false;
          this.toShowForm = true;
          const myButton = document.getElementById("toClick");
          this.simulateMouseClick(myButton);
          // this.parentData.ref.closeAll();
          console.log(this.toShowPlatformPlans, this.toShowForm);
          this._apiService.getSubcriptionHistoryById(
            localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
            "1",
            this.countryInfo.countryCode
          );
          this.toShowMonths = false;
          this.toShowEmployees = false;
          this.noOfMonths = 1;
          this.noOfEmployees = 1;
        }
      }
    });
  }
  selectedPlan: any = [];
  toShowForm: boolean = false;
  toShowExistingPlans: boolean = false;
  toShowPlatformPlans: boolean = false;
  createBusinessWithExistingSubs(item: any) {
    // if(confirm("Are you sure you want to add the business on this subscription?")){
    //   this.selectedPlan = []
    //   this.selectedPlan.push(item)
    //   this.toShowForm = true
    //   this.toShowExistingPlans = false
    // }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message:
          "Are you sure you want to add the employee on this subscription?",
        okbtn: "Confirm",
        cancelbtn: "Cancel",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.selectedPlan = [];
        this.selectedPlan.push(item);
        this.toShowForm = true;
        this.toShowExistingPlans = false;
      }
    });
  }
  serviceType: any = [];
  clickTypeCheckbox(event: any) {
    if (event.checked) {
      this.serviceType.push(event.source.value);
    } else if (!event.checked) {
      const index = this.serviceType.findIndex(
        (x: any) => x == event.source.value
      );
      this.serviceType.splice(index, 1);
    }

    console.log(this.serviceType);
  }
  addNewSubs() {
    this.toShowExistingPlans = false;
    this.toShowPlatformPlans = true;
    this.toShowMonths = false;
    this.toShowEmployees = false;
    this.noOfMonths = 1;
    this.noOfEmployees = 1;
  }

  clickAvailabilityCheckbox(event: any) {
    if (event.checked) {
      this.newEmployeeObj.entityStatus = 1;
    } else if (!event.checked) {
      this.newEmployeeObj.entityStatus = 0;
    }
  }
  homeServiceAvailable: boolean = false;
  shopServiceAvailable: boolean = false;
  clickServiceAvailabilityCheckbox(event: any, type: any) {
    if (event.checked) {
      if (type == 0) {
        this.homeServiceAvailable = true;
      } else if (type == 1) {
        this.shopServiceAvailable = true;
      }
    } else if (!event.checked) {
      if (type == 0) {
        this.homeServiceAvailable = false;
      } else if (type == 1) {
        this.shopServiceAvailable = false;
      }
    }
  }

  goBack() {
    this.toShowExistingPlans = true;
    this.toShowForm = false;
  }

  onSubmit() {
    if (this.editmode) {
      let data = {
        employeeInfo: {
           name: this.newEmployeeObj.requestUserName,
          phone: this.newEmployeeObj.employee_phone,
          country_code: this.selectedCountryCode.dial_code,
          note: this.newEmployeeObj.note,
          dob: this.parentData.data.dob ? this.parentData.data.dob.slice(0, 10) : null,
          dateOfJoin: this.newEmployeeObj.joiningDate
            ? this.formatDate1(this.newEmployeeObj.joiningDate)
            : null,
          joiningSalary: this.newEmployeeObj.joiningSalary,
          // shortBio: this.parentData.data.shortBio
        },
      };
      Object.keys(data.employeeInfo).forEach((key) => {
        if ((data.employeeInfo as any)[key] === null) {
          delete (data.employeeInfo as any)[key];
        }
      });
      console.log(data);

      this.loaderService.showLoader = true;
      this._apiService.updateEmployeeInfo(
        this.parentData.data.employee_hash_id,
        data
      );
    } else {
      let data = {
        requestInfo: {
          title: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_NAME),
          note: this.newEmployeeObj.note
            ? this.newEmployeeObj.note
            : "No notes added",
          requestUserName: this.newEmployeeObj.requestUserName,
          requestUserPhone: this.newEmployeeObj.requestUserPhone,
          joiningDate: this.newEmployeeObj.joiningDate
            ? this.formatDate(
                new Date(this.newEmployeeObj.joiningDate).toLocaleDateString()
              )
            : null,
          subscriptionHash: this.selectedPlan[0].hash_id,
          joiningSalary:
            this.newEmployeeObj.joiningSalary +
            ", " +
            this.newEmployeeObj.salaryType,
        },
      };
      console.log(data, localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH));

      this.loaderService.showLoader = true;
      this._apiService.sendEmployeeRequest(
        localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_HASH),
        data
      );
    }
  }

  selectedPlatformPlan: any = [];
  toShowMonths: boolean = false;
  toShowEmployees: boolean = false;
  onSelectPlan(item: any) {
    if (item.isExpired == 0) {
      if (item.validity_count == 30 && item.perUnitCost > 0) {
        this.toShowMonths = true;
        this.toShowEmployees = false;
        this.noOfMonths = 1;
        this.noOfEmployees = 1;
      } else if (item.validity_count == 365 && item.perUnitCost > 0) {
        this.toShowMonths = false;
        this.toShowEmployees = true;
        this.noOfMonths = 1;
        this.noOfEmployees = 1;
      } else if (item.validity_count == 30 && item.perUnitCost == 0) {
        this.toShowMonths = false;
        this.toShowEmployees = false;
        this.noOfMonths = 1;
        this.noOfEmployees = 1;
      }

      this.plansList.forEach((element: any) => {
        element.selected = false;
      });
      item.selected = true;
      this.selectedPlan = [];
      this.selectedPlan.push(item);
    }
  }

  onContinue() {
    if (this.selectedPlan[0].perUnitCost > 0) {
      let data = {
        amount: (
          this.selectedPlan[0].perUnitCost *
          100 *
          this.noOfMonths *
          this.noOfEmployees
        ).toString(),
        currency: "INR",
        receipt: this.generateReceiptNumber(),
        currency_symbol: this.selectedPlan.currency_symbol,
          plan_hash: this.selectedPlan.hash_id,
          account_hash: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
          no_of_entity: 0,
          no_of_users: this.noOfEmployees,
          total_cost: this.selectedPlan.perUnitCost *
                  this.noOfMonths *
                  this.noOfEmployees,
          unit_cost: this.selectedPlan.perUnitCost,
          created_by: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID),
      };

      console.log(data);

      this._apiService.createSubscriptionOrder(data);
    } else {
      this.paymentResponse = {
        signature: "test",
      };
      let data = {
        transactionInfo: {
          planHash: this.selectedPlan[0].hash_id,
          noOfUsers: 5,
          noOfEntity: 0,
          fromDate: this.formatDateString(new Date()),
          toDate: this.addDaysToDate(
            new Date(),
            +this.selectedPlan[0].validity.split(" ")[0]
          ),
          validity: +this.selectedPlan[0].validity.split(" ")[0],
          totalCost: this.selectedPlan[0].perUnitCost,
          unitCost: this.selectedPlan[0].perUnitCost,
          paymentType: 1,
          paymentRef: "",
          currency: this.selectedPlan[0].currency,
          currencySymbol: this.selectedPlan[0].currency_symbol,
        },
      };

      this._apiService.updatePaymentRecord(data);
    }
  }

  changeNoOfMonths(value: any) {
    if (value == 0) {
      this.noOfMonths -= 1;
    } else if (value == 1) {
      this.noOfMonths += 1;
    }
  }
  changeNoOfEmployees(value: any) {
    if (value == 0) {
      this.noOfEmployees -= 1;
    } else if (value == 1) {
      this.noOfEmployees += 1;
    }
  }

  /**LOCATION AUTOCOMPLETE FUNCTION */
  GoogleAutocomplete = new google.maps.places.AutocompleteService();
  geocoder = new google.maps.Geocoder();
  autocompleteItems: any = [];
  selectedLocation: any = [];
  formattedAddress: any;
  lat: any;
  lng: any;
  updateSearchResults() {
    console.log("Text enter");
    if (
      this.newEmployeeObj.addressInfo.addressLine == "" ||
      this.newEmployeeObj.addressInfo.addressLine == null
    ) {
      this.autocompleteItems = [];
      return;
    }
    this.GoogleAutocomplete.getPlacePredictions(
      {
        input: this.newEmployeeObj.addressInfo.addressLine,
      },
      (predictions: any, status: any) => {
        console.log(predictions, status);
        this.autocompleteItems = [];
        predictions.forEach((prediction: any) => {
          this.autocompleteItems.push(prediction);
        });
      }
    );
  }
  selectSearchResult(item: any) {
    console.log(item);
    this.autocompleteItems = [];
    this.geocoder.geocode(
      {
        placeId: item.place_id,
      },
      (results: any, status: any) => {
        if (status === "OK" && results[0]) {
          this.ngZone.run(() => {
            // this.personalInfoForm.value.address = results[ 0 ].formatted_address;
            this.newEmployeeObj.addressInfo.addressLine =
              results[0].formatted_address;
            // this.personalInfoForm.get('address').patchValue(results[0].formatted_address);
            // this.locationSelected = true;
            let location_set: any = JSON.stringify(results[0].geometry);
            location_set = JSON.parse(location_set);
            let position = {
              lat: results[0].geometry.location.lat,
              lng: results[0].geometry.location.lng,
            };
            this.lat = location_set.location.lat;
            this.lng = location_set.location.lng;
            console.log(this.lat, this.lng);
            console.log("Latitude & Langitude", position);
            this.storeLocation(
              results[0].address_components,
              results[0].formatted_address
            );
          });
        }
      }
    );
  }
  storeLocation(location: any, formatted_address: any) {
    console.log(location);

    const selectedLocation: any = {};
    location.forEach((element: any) => {
      console.log(element, element.types.includes("postal_code"));
      if (element.types.includes("postal_code")) {
        selectedLocation.zip = element.long_name;
      } else if (element.types.includes("country")) {
        selectedLocation.country = element.long_name;
      } else if (element.types.includes("administrative_area_level_1")) {
        selectedLocation.state = element.long_name;
      } else if (element.types.includes("locality")) {
        selectedLocation.city = element.long_name;
      } else if (element.types.includes("route")) {
        selectedLocation.address = element.long_name;
      }
    });
    this.formattedAddress = formatted_address;
    this.selectedLocation = selectedLocation;
  }

  formatDateString(inputDateString: Date): string {
    const inputDate = new Date(inputDateString);
    const year = inputDate.getFullYear();
    const month = (inputDate.getMonth() + 1).toString().padStart(2, "0"); // Month is 0-indexed
    const day = inputDate.getDate().toString().padStart(2, "0");
    const hours = inputDate.getHours().toString().padStart(2, "0");
    const minutes = inputDate.getMinutes().toString().padStart(2, "0");
    const seconds = inputDate.getSeconds().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  addDaysToDate(currentDate: Date, daysToAdd: number): string {
    const newDate = new Date(currentDate);
    newDate.setDate(newDate.getDate() + daysToAdd);

    const year = newDate.getFullYear();
    const month = String(newDate.getMonth() + 1).padStart(2, "0");
    const day = String(newDate.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  generateReceiptNumber(): string {
    return uuidv4();
  }

  paymentResponse: any = null;
  payWithRazor(val: any, amount: any) {
    console.log(val, amount);

    const options: any = {
      //OLD KEY
      // key: 'rzp_test_Z3ZWXkX2GZF6Hd',

      //NEW KEY
      key: environment.razorpayKey,

      amount: amount, // amount should be in paise format to display Rs 1255 without decimal point

      currency: "INR",

      order_id: val, // order_id created by you in backend

      modal: {
        // We should prevent closing of the form when esc key is pressed.

        escape: false,
      },

      theme: {
        color: "#0c238a",
      },
    };

    options.handler = (response: any, error: any) => {
      options.response = response;

      console.log(response);

      this.paymentResponse = response;

      this._apiService.validatePaymentSignature(response);

      // call your backend api to verify payment signature & capture transaction
    };

    options.modal.ondismiss = () => {
      // handle the case when user closes the form while transaction is in progress
      const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
        data: {
          title: "Alert",
          message:
            "The payment process interrupted and couldn't be completed. Try again if not done intentionally.",
          okbtn: "Ok",
          cancelbtn: "Ok",
          type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
        },
        disableClose: true,
      });
      console.log("Transaction cancelled.");
    };

    const rzp = new this.winRef.nativeWindow.Razorpay(options);

    rzp.open();
  }

  forceUpdate() {
    console.log("myomy");

    this.cdr.detectChanges();
  }
  simulateMouseClick(element: any) {
    const clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });

    element.dispatchEvent(clickEvent);
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split("/");
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }
      formatDate1(dateStr:Date) {

    let curdate = new Date(dateStr).toLocaleString('en-CA', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' 
  }).slice(0, 10);

      return curdate
  }

  countryList: {
    name: string;
    dial_code: string;
    code: string;
    flag: string;
    preferred?: any;
  }[] = COUNTRY_CODES;
  selectedCountryCode: any = this.countryList.find(
    (country) =>
      country.dial_code === this.countryInfo.countryCode &&
      country.code === this.countryInfo.code
  );
  searchString: FormControl = new FormControl("");
  onCountrySelected(event: any): void {
    this.searchString.reset();
    this.countryList = COUNTRY_CODES;
  }

  onKey() {
    console.log(this.searchString.value);

    this.countryList = [];
    this.selectSearch(this.searchString.value);
  }
  selectSearch(value: string) {
    let filter = value.toLowerCase();
    for (let i = 0; i < COUNTRY_CODES.length; i++) {
      let option = COUNTRY_CODES[i];
      if (option.name.toLowerCase().indexOf(filter) >= 0) {
        this.countryList.push(option);
      }
    }
  }
}
